import vCard from './Card';

export { vCard };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Card/index.js